import { IRentsyncSettings } from '@llws/lift-entity-interfaces';

export const getNewRentsyncSetting = (
  fieldKey: string,
  value?: string | null,
  feedKey?: string | null,
  partnerKey?: string | null,
  clientId?: number | null,
  buildingId?: number | null,
  suiteTypeId?: number | null,
): IRentsyncSettings => {
  const newRentsyncSetting: IRentsyncSettings = {
    fieldKey,
    value,
    feedKey,
    partnerKey,
    clientId,
    buildingId,
    suiteTypeId,
    created: new Date(),
    id: undefined,
  };
  return newRentsyncSetting;
};
